export default __webpack_public_path__ + "static/media/190629_190332_IMG_4691.dddf8f1c.jpg";